const experience = [
    {
        company: 'Meta',
        role: 'Software Engineer · Instagram iOS',
        date: 'Jan 2025 – Present',
        location: 'San Francisco, CA',
        stack: 'Swift · Objective-C · Machine Learning · Experimentation',
        details: [
            'Shipped camera preview player, audio lead-in, and teleprompter lyrics features for Instagram Reels creation on iOS, serving 2B+ users.',
            'Implemented ML-powered green screen with background segmentation for the Reels camera.',
            'Designed and ran Reels Creation simplification experiments end-to-end, including holdout infrastructure and creator-engagement measurement.',
        ],
    },
    {
        company: 'Meta',
        role: 'Software Engineering Intern',
        date: 'May – Aug 2025',
        location: 'Menlo Park, CA',
        stack: 'Swift · Objective-C · Django · iOS Development · GraphQL',
        details: [
            'Implemented and launched offline syncing for likes, follows, and comments, enabling interactions without a connection.',
            'Increased annual Instagram interactions by 1 billion (0.2–0.5%), improving creator engagement and downstream metrics.',
            'Redesigned GraphQL APIs for more efficient batched likes and follows.',
        ],
    },
    {
        company: 'Cisco Meraki',
        role: 'Software Engineer Intern',
        date: 'Sep – Dec 2024',
        location: 'San Francisco, CA',
        stack: 'React Native · Ruby on Rails · Mobile Development · PostgreSQL',
        details: [
            'Led a cross-team collaboration between Secure Connect and Mobile, establishing a blueprint for future mobile-platform development.',
            'Developed the Secure Connect Mobile Dashboard so customers could view connectivity and usage data in the Meraki app.',
            'Built notification and monitoring APIs supporting more than 500 enterprise users.',
        ],
    },
    {
        company: 'Somos, Inc.',
        role: 'Software Engineering Intern',
        date: 'May – Aug 2024',
        location: 'Union City, CA',
        stack: 'AWS · Serverless · Cloud Computing · Agile · TypeScript · React · JUnit',
        details: [
            'Worked on the RealBrand product using a cloud-based microservices architecture.',
            'Deployed Lambda, API Gateway, DynamoDB, SQS, and SNS services connecting a microservices platform.',
            'Implemented frontend and backend functionality with TypeScript and React alongside JUnit test coverage.',
            'Created development and UI standards used by more than 150 employees and developers.',
        ],
    },
    {
        company: 'Purdue University · WeBee Smart Irrigation',
        role: 'Lead Undergraduate Data Science Researcher',
        date: 'Aug 2022 – May 2023',
        location: 'West Lafayette, IN',
        stack: 'Data Analysis · Python · R · SQL · REST APIs · Statistics',
        details: [
            'Developed a data pipeline using the WHIM REST API, R, Python, and SQL to store weather-system data.',
            'Analyzed South American WeBee moisture-sensor data and developed a prediction model to optimize agricultural freshwater usage.',
        ],
    },
    {
        company: 'University of Chicago',
        role: 'Research Assistant · Backend Software Developer',
        date: 'Oct 2021 – Jan 2022',
        location: 'Chicago, IL',
        stack: 'Node.js · HTML/CSS · JavaScript · REST APIs · Firebase',
        details: [
            'Worked with Noelle Huang and Professor John List’s team at the Kenneth C. Griffin Department of Economics to improve research data gathering.',
            'Created backend architecture, integrations, and documentation for the team’s data-collection needs using Ease Attendance and supporting microservices.',
            'Designed and implemented a responsive dashboard for viewing study data.',
        ],
    },
];

export default experience;
